<template>
  <v-container fluid class="pt-0 mt-0">
    <v-row>
      <v-spacer />
      <v-col cols="12" md="11">
        <v-card class="mx-auto">
          <v-toolbar color="teal" dark class="text-xs-center">
            <v-toolbar-title style="color: white" @click="currentItem = null">The European Palm Society Database
            </v-toolbar-title>
          </v-toolbar>
        </v-card>
      </v-col>
      <v-spacer />
    </v-row>

    <v-row>
      <v-spacer />
      <v-col cols="12" md="3">
        <v-expansion-panels v-if="genusData">
          <v-expansion-panel v-for="genus in genusData.filter((genus) => genus.genusComments)" :key="genus.genusId">
            <v-expansion-panel-header @click="currentItem = genus">
              {{ genus.genus }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list flat>
                <v-list-item-group color="primary">
                  <v-list-item class="ma-0 pa-0" v-for="species in genus.genusSpecies.filter(
                    (species) => species.speciesId > 0
                  )" :key="species.speciesId" @click="currentItem = species">
                    <v-list-item-icon class="pa-0 mr-2 ml-0">
                      <v-icon>mdi-palm-tree</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="pa-0">
                      <v-list-item-title v-text="species.species"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>

      <v-col cols="12" md="8">
        <v-row v-if="currentItem && currentItem.speciesId">
          <v-col cols="12">
            <v-card>
              <v-card-title>
                {{
                    genusData.filter((genus) => genus.genusId === currentItem.genusId)[0]
                      .genus
                }}
                {{ currentItem.species }}
              </v-card-title>
              <v-card-text class="black-text"><b>Genus:</b>
                {{
                    genusData.filter((genus) => genus.genusId === currentItem.genusId)[0]
                      .genus
                }}
              </v-card-text>
              <v-card-text class="black-text"><b>Species:</b> {{ currentItem.species }}</v-card-text>
              <v-card-text class="black-text"><b>Common Name:</b> {{ currentItem.speciesCommonName }}</v-card-text>
              <v-card-text class="black-text"><b>Country Of Origin:</b> {{ currentItem.speciesCountry }}</v-card-text>
              <v-card-text class="black-text"><b>Typical Dimensions:</b> <span v-html="currentItem.dimensions" /></v-card-text>
              <v-card-text class="black-text"><b>Soil Preferences:</b> <span v-html="currentItem.soil" /></v-card-text>
              <v-card-text class="black-text"><b>Preferred Aspect:</b> <span v-html="currentItem.aspect" /></v-card-text>
              <v-card-text class="black-text"><b>Minimum Temp:</b> <span v-html="currentItem.minTemp" /></v-card-text>
              <v-card-text class="black-text"><b>Seed Tips:</b> <span v-html="currentItem.seedTips" /></v-card-text>
              <v-card-text class="black-text"><b>General Comments:</b> <span v-html="currentItem.speciesComments" /></v-card-text>
            </v-card>
          </v-col>
          <v-spacer />

        </v-row>

        <v-row v-if="currentItem && currentItem.genusSpecies">
          <v-col cols="12">
            <h1>{{ currentItem.genus }}</h1>
            <span v-html="currentItem.genusComments"> </span>
          </v-col>
        </v-row>

        <v-row v-if="!currentItem">
          <v-col cols="12" md="9">
            <v-card>
              <v-card-title class="word-wrap">Welcome to the EPS Palm and Exotic plant database</v-card-title>

              <v-card-text class="black-text">This is an exciting long term project where we would like over time to
                gather submissions from members of their experiences of growing palms and
                other exotic plants. The idea is not to end up with a check list of all
                the palms of the world but to concentrate on those we are growing. The
                resource we create will be publicly accessible so we can share our
                experiences with as many people as possible.</v-card-text>

              <v-card-text class="black-text">
                If will be good to build a picture of how the plants perform across the
                varied climates and conditions we all garden under. Over time we should
                get a good reference for temperature ranges the plants are experiencing
                and what impact that has, tips for seed germination, soil preferences and
                importantly photographs of the plants. If we can build these reports from
                many members we get an excellent reference of data for each
                plant.</v-card-text>
              <v-card-text class="black-text">We propose to have entries for the various varieties that we tend to
                recognise as gardeners as we know these are often not recognised under any
                scientific naming convention. But by having such entries with pictures we
                can start to see if there are recognisable differences that merit the
                naming from a horticultural point of view.</v-card-text>
              <v-card-text class="black-text">Please use the suggestions form link to send us your submission. This can
                be to add a new species or variety entry or to add to an existing one. We
                will get back in touch with a means to send us any accompanying
                photographs if you have any. Pictures must be your own or come with the
                permission of the owner for us to re-use them on the site.</v-card-text>
              <v-card-text class="black-text">Please be patient once you have made your submission. It is likely to
                take us a few days to review, prepare and upload them. There are just a
                small number of us 'behind the scenes' and things could get busy at times.
              </v-card-text>
              <v-card-subtitle class="black-text">I hope you will support this initiative and find it
                beneficial</v-card-subtitle>
            </v-card>
          </v-col>
          <v-col cols="12" md="3">
            <v-card class="ma-2">
              <v-img src="https://www.palmsociety.org.uk/rome/rome-may-2012-355.jpg" />
            </v-card>

            <v-card class="ma-2">
              <v-img src="https://www.palmsociety.org.uk/rome/rome-may-2012-392.jpg" />
            </v-card>
            <v-card class="ma-2">
              <v-img src="https://www.palmsociety.org.uk/rome/rome-may-2012-525.jpg" />
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-spacer />
    </v-row>
  </v-container>
</template>

<script>
import userFunctions from "@/functions/userFunctions";

export default {
  name: "PalmInfo",
  methods: {
    async getAPIData() {
      const res = await fetch(process.env.VUE_APP_SERVER_URL + "/getPalmDB", {
        method: "get",
      });
      const data = await res.json();
      this.genusData = data.result;
      userFunctions.updateLastViewed("palminfo");
    },
  },
  data: () => ({
    genusData: null,
    currentItem: null,
  }),
  beforeMount() {
    this.getAPIData();
  },
};
</script>

<style scoped>
.palm-site-green {
  background-color: rgb(176, 217, 173);
}

.word-wrap {
  word-break: break-word;
}
</style>
